import React, { useState } from "react";
import styles from "./OrderEditUserImageBox.module.css";

const OrderEditUserImageBox = ({
  imageUrls,
  imagesPerRow,
  width,
  height,
  albumType,
}) => {
  const [zoomedImageUrl, setZoomedImageUrl] = useState(null);

  const handleImageClick = (imageUrl) => {
    setZoomedImageUrl(imageUrl);
  };

  const handleCloseZoom = () => {
    setZoomedImageUrl(null);
  };

  // At first, I have calculated the number of rows based on the imagesPerRow prop (6/2 = 3; meaning two images per row and total 3 rows)
  const rowCount = Math.ceil(imageUrls.length / imagesPerRow);

  // Group the images into rows (so now the structure is like [[url1, url2], [url3, url4]])
  const imageRows = [];
  for (let i = 0; i < rowCount; i++) {
    imageRows.push(imageUrls.slice(i * imagesPerRow, (i + 1) * imagesPerRow));
  }

  return (
    <div className={styles.userImageBox}>
      {imageRows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className={styles.userImageRow}
          style={
            imagesPerRow === 1
              ? { justifyContent: "center" }
              : { justifyContent: "start" }
          }
        >
          {row.map((imageUrl, index) => (
            <div
              key={index}
              onClick={() => handleImageClick(imageUrl)}
              className={styles.imageContainer}
            >
              <img
                src={imageUrl}
                alt={`${rowIndex * imagesPerRow + index + 1}`}
                className={styles.userImage}
                style={albumType ? { borderWidth: "0px" } : {}}
                width={width}
                height={height}
              />
            </div>
          ))}
        </div>
      ))}
      {zoomedImageUrl && (
        <div className={styles.zoomedImageOverlay} onClick={handleCloseZoom}>
          <span className={styles.closeButton} onClick={handleCloseZoom}>
            &times;
          </span>
          <img
            src={zoomedImageUrl}
            alt="Zoomed "
            className={styles.zoomedImage}
          />
        </div>
      )}
    </div>
  );
};

export default OrderEditUserImageBox;
